import { createContext, useContext } from 'react';
const PortalContext = /*#__PURE__*/createContext(null);
/**
 * @private
 * @internal Don't even try to use it
 */
export function usePortalContext() {
  const root = useContext(PortalContext);
  return {
    root
  };
}
/**
 * @private
 * @internal Don't even try to use it
 */
export const PortalProvider = PortalContext.Provider;